(function () {
  const consentmoStyleId = 'elysee-consentmo-mobile-widget-offsets';
  const adaStyleId = 'elysee-ada-mobile-widget-offsets';
  const defaultOffsetPx = 128;
  const widgetBottom = `var(--elysee-mobile-widget-bottom-offset, calc(${defaultOffsetPx}px + env(safe-area-inset-bottom, 0px)))`;
  const consentmoHostSelector = 'csm-cookie-consent, .csm-cmp-root';

  const consentmoShadowCss = `
    @media (max-width: 749px) {
      :host {
        --elysee-mobile-widget-safe-bottom: ${widgetBottom};
      }

      .rT6DfJL06Wddyt6r5rCQ,
      .QHJ2aqDoEOZbcMWf9BxL,
      .nUq3103wCWsjK0SoPHOw,
      .h8V3bJhUSIptU8vdexyX,
      .CA2rTKQjNeSPfoCYA3oV,
      .IWNjC50QfbIojCFTrCAZ,
      .SOYR0oPj0Q6UOw2AemzM {
        bottom: var(--elysee-mobile-widget-safe-bottom) !important;
        top: auto !important;
      }

      .KnYTvlwzOy23sXYIabrN {
        bottom: calc(var(--elysee-mobile-widget-safe-bottom) + 40px) !important;
      }

      [style*="bottom: 0"],
      [style*="bottom:0"],
      [style*="bottom: 1em"],
      [style*="bottom:1em"] {
        bottom: var(--elysee-mobile-widget-safe-bottom) !important;
      }
    }
  `;

  const adaShadowCss = `
    @media (max-width: 749px) {
      :host {
        --ada-banner-bottom-px: ${widgetBottom};
        --elysee-mobile-widget-safe-bottom: ${widgetBottom};
      }

      .csm-ada-compliance,
      .TmCIazCWB1fPALe1iLC3,
      .UlvRARIgTXbFRCwCAjFm,
      .I7CVVmuYNWfIvY0nxags {
        bottom: var(--elysee-mobile-widget-safe-bottom) !important;
        top: auto !important;
      }
    }
  `;

  function applyAdaOffset() {
    document.querySelectorAll('csm-web-accessibility').forEach((host) => {
      host.style.setProperty('--ada-banner-bottom-px', widgetBottom, 'important');
      host.style.setProperty('--elysee-mobile-widget-safe-bottom', widgetBottom, 'important');
      injectShadowStyles(host, adaStyleId, adaShadowCss);
      offsetSmallFixedControls(host.shadowRoot);
    });
  }

  function injectShadowStyles(host, styleId, css) {
    if (!host.shadowRoot || host.shadowRoot.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = css;
    host.shadowRoot.appendChild(style);
  }

  function offsetSmallFixedControls(root) {
    if (!root || !window.matchMedia('(max-width: 749px)').matches) return;

    root.querySelectorAll('*').forEach((element) => {
      const style = window.getComputedStyle(element);
      if (style.position !== 'fixed') return;

      const rect = element.getBoundingClientRect();
      const isSmallControl = rect.width <= 140 && rect.height <= 140;
      const className = typeof element.className === 'string' ? element.className : '';
      const isKnownWidget =
        className.includes('TmCIazCWB1fPALe1iLC3') ||
        className.includes('SOYR0oPj0Q6UOw2AemzM') ||
        className.includes('KnYTvlwzOy23sXYIabrN');

      if (!isSmallControl && !isKnownWidget) return;

      element.style.setProperty('bottom', widgetBottom, 'important');
      element.style.setProperty('top', 'auto', 'important');
    });
  }

  function updateWidgetBottomOffset() {
    if (!window.matchMedia('(max-width: 749px)').matches) {
      document.documentElement.style.removeProperty('--elysee-mobile-widget-bottom-offset');
      return;
    }

    const stickyBar = document.querySelector('.sticky-add-to-cart__bar');
    const rect = stickyBar?.getBoundingClientRect();
    const measuredOffset = rect?.height ? Math.ceil(rect.height + 32) : defaultOffsetPx;
    const offset = Math.max(defaultOffsetPx, measuredOffset);

    document.documentElement.style.setProperty(
      '--elysee-mobile-widget-bottom-offset',
      `calc(${offset}px + env(safe-area-inset-bottom, 0px))`
    );
  }

  function offsetDocumentFixedControls() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    const selectors = [
      'csm-web-accessibility',
      'csm-cookie-consent',
      '.csm-cmp-root',
      '#PBarNextFrameWrapper',
      '#PBarNextFrame',
      '[id*="accessibility" i]',
      '[class*="accessibility" i]',
      '[id*="ada" i]',
      '[class*="ada" i]',
      '[id*="consent" i]',
      '[class*="consent" i]',
      '[id*="cookie" i]',
      '[class*="cookie" i]',
      '[id*="privacy" i]',
      '[class*="privacy" i]',
    ].join(',');

    document.querySelectorAll(selectors).forEach((element) => {
      if (element.closest('sticky-add-to-cart, .sticky-add-to-cart__bar, .shopify-section-header')) return;

      const style = window.getComputedStyle(element);
      const rect = element.getBoundingClientRect();
      const isFixed = style.position === 'fixed';
      const isSmallControl = rect.width <= 180 && rect.height <= 180;
      const isNearBottom = rect.bottom >= window.innerHeight - 220;
      const isNearSide = rect.left <= 180 || window.innerWidth - rect.right <= 180;

      if (!isFixed || !isSmallControl || !isNearBottom || !isNearSide) return;

      element.style.setProperty('bottom', widgetBottom, 'important');
      element.style.setProperty('top', 'auto', 'important');
    });
  }

  function applyConsentmoOffset() {
    document.querySelectorAll(consentmoHostSelector).forEach((host) => {
      injectShadowStyles(host, consentmoStyleId, consentmoShadowCss);
      offsetSmallFixedControls(host.shadowRoot);
    });
  }

  function refresh() {
    updateWidgetBottomOffset();
    applyAdaOffset();
    applyConsentmoOffset();
    offsetDocumentFixedControls();
  }

  let scheduled = false;

  function scheduleRefresh() {
    if (scheduled) return;

    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      refresh();
    });
  }

  refresh();
  window.addEventListener('load', refresh, { once: true });
  window.addEventListener('resize', scheduleRefresh);
  window.addEventListener('orientationchange', scheduleRefresh);
  document.addEventListener('consentmo:accessibilityReady', refresh);

  const observer = new MutationObserver(scheduleRefresh);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
